module.exports = __webpack_public_path__ + "media/images/icon-transcribe-5b0f630dabee678e57108205a29221da.svg";